import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { ReportFormRuleTemplate } from '@navstation-portal/reporting/data-model/ui';

/**
 * DEV-ONLY form-rule template debug. Delete this file, its provider, and
 * `form-rule-template-debug.component.ts` to remove the template debug UI.
 * Nothing in the report load path knows it exists: the debug component
 * dispatches the same `gotFormRuleTemplate` event the load path dispatches.
 *
 * It stays apart from `ReportApiService` on purpose. A debug call belongs to
 * no report, and mixing the two would make the real interface hold a method
 * that has to leave again later.
 */
export interface ReportDebugApiService {
  /** Every template name the server holds, 'base' first. */
  getFormRuleTemplateNames(): Observable<string[]>;
  /**
   * The 'base' template with each named template applied over it, in order,
   * and then the vessel's Vessel Form Rule Override while
   * applyVesselOverride is true. The server merges, so the debug UI shows the
   * merge a report gets and never a second copy of it.
   */
  getMergedFormRuleTemplate(
    names: string[],
    vesselId: string,
    applyVesselOverride: boolean
  ): Observable<ReportFormRuleTemplate>;
}

export const REPORT_DEBUG_API_SERVICE = new InjectionToken<ReportDebugApiService>('REPORT_DEBUG_API_SERVICE');
